import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon"];
  static values = { content: String };

  copy() {
    navigator.clipboard.writeText(this.contentValue);
    this._showConfirmation();
  }

  disconnect() {
    clearTimeout(this._timeout);
  }

  _showConfirmation() {
    this.iconTarget.textContent = "check";
    clearTimeout(this._timeout);
    this._timeout = setTimeout(() => {
      this.iconTarget.textContent = "content_copy";
    }, 2000);
  }
}
